import styled from "@emotion/styled";

export interface TableCellProps {
  minWidth?: number;
  padding?: number;
  overflow?: "hidden" | "visible" | "scroll" | "auto";
}

export const TableCell = styled.div<TableCellProps>(({ minWidth, padding, overflow }) => ({
  display: "grid",
  minWidth: minWidth ? `${minWidth}px` : "auto",
  margin: 0,
  padding: padding ?? 0,
  overflow,
}));

export const LogoImage = styled.img({
  width: 16,
  height: 16,
  objectFit: "contain",
  borderRadius: 4,
});

export const EmptyLogoImage = styled.div(({ theme }) => ({
  width: 16,
  height: 16,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 2,
  color: theme.colors.sysTextDefault,
  backgroundColor: theme.colors.sysBorderDecorative,
  borderRadius: 4,
}));
